import { useMemo } from 'react';

import { AccountMilestoneWithRequirements, MilestoneTemplateType } from 'types';

// Only type/order/completed are read below; narrowing to these lets callers (including tests)
// pass minimal milestone objects instead of the full AccountMilestoneWithRequirements shape.
type MilestoneForPrecedingCheck = Pick<AccountMilestoneWithRequirements, 'type' | 'order' | 'completed'>;

export const useArePrecedingMilestonesCompleted = (
  milestones: Array<MilestoneForPrecedingCheck> | undefined,
  targetMilestoneType: MilestoneTemplateType,
): boolean => {
  return useMemo(() => {
    if (!milestones?.length) return false;

    const targetMilestone = milestones.find((m) => m.type === targetMilestoneType);
    if (!targetMilestone) return false;

    return milestones.filter((m) => m.order < targetMilestone.order).every((m) => m.completed);
  }, [milestones, targetMilestoneType]);
};
